export default "__VITE_ASSET__koA_NAPL__"